
	import Component from 'vue-class-component'
	import moduleStore from './store/moyouPic';
	import Vue from 'vue';
	import PageState from './store/state';
	import { judgeDeviceType } from '@/utils/device';


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class moyouPicPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		showDialog = false;
		isAPP = judgeDeviceType.isAPP;
		imgDataList=[
			{
				imgSrc:"/images/moyou/moyou01.png",
				id:'1'

			},
			{
				imgSrc:"/images/moyou/moyou02.png",
				id:'2'
			},
			{
				imgSrc:"/images/moyou/moyou03.png",
				id:'3',
				function:"turnToPath",
				param:""
			},
			{
				imgSrc:"/images/moyou/moyou04.png",
				id:'4'
			},
			{
				imgSrc:"/images/moyou/moyou05.png",
				id:'5'

			},
			{
				imgSrc:"/images/moyou/moyou06.png",
				id:'6'
			},
			{
				imgSrc:"/images/moyou/moyou07.png",
				id:'7'
			},
			{
				imgSrc:"/images/moyou/moyou08.png",
				id:'8'
			},
			{
				imgSrc:"/images/moyou/moyou09.png",
				id:'9'
			},
			{
				imgSrc:"/images/moyou/moyou10.png",
				id:'10'
			}
		]
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
	
			this.state.title="这是更改后的title"
			this.state.self = this;
		}
		imgClick(id:string){
			switch (id) {
				case "3":
					if(this.isAPP){
						this.$router.push({
							path:"/accredit"
						})
					}else{
						this.$navigateTo({
							url: `/pages/webview/webview?url=${encodeURIComponent(`${location.origin}/#/accredit`)}&navtitle=魔友活动` 
						})
					}
					break;
				case "6":
					this.showDialog = true
				break;
				case "9":
					this.showDialog = true
				break;
			
				default:
					break;
			}
		}
		gotoRecharge(){
			if(this.isAPP){
				let switchToVipPage=(<any>window).switchToVipPage;
				switchToVipPage.postMessage("");
			}
			this.$navigateTo({
				url: `/pages/recharge-vip/recharge-vip`
			});
		}
	
	}